import api from '../callApi';

const completeVideo = (apiRequestData, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        actionCompletedTime
    };

    return api
        .post('Widget/CompleteVideoAsync', request, {
            useFingerprint: true
        })
        .then(response => response);
};

export default completeVideo;
